module.exports = __webpack_public_path__ + "static/media/pin-truck.afbfedfb.svg";